/** @format */

import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';

// Components
import { HomefieldProductImageComponent } from './product-image.component';

@NgModule({
	imports: [CommonModule, NgOptimizedImage],
	declarations: [HomefieldProductImageComponent],
	exports: [HomefieldProductImageComponent]
})
export class HomefieldProductImageModule {}
